const musicNotes = ['♪', '♫', '♬', '♩', '♭', '♮']
const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeead']

export function initCursorEffect(selector = 'body') {
  const target = document.querySelector(selector)
  if (!target) return

  target.addEventListener('click', createMusicNote)
}

function createMusicNote(e: MouseEvent) {
  const note = document.createElement('div')
  note.className = 'cursor-effect'

  // 随机选择音符和颜色
  const randomNote = musicNotes[Math.floor(Math.random() * musicNotes.length)]
  const randomColor = colors[Math.floor(Math.random() * colors.length)]

  note.style.setProperty('--note', `"${randomNote}"`)
  note.style.setProperty('--note-color', randomColor)

  // 设置位置
  note.style.left = `${e.clientX}px`
  note.style.top = `${e.clientY}px`

  document.body.appendChild(note)

  // 动画结束后移除元素
  note.addEventListener('animationend', () => {
    note.remove()
  })
}
